// Yofis — контракт API `yofis.v1`. Вход, сессии, регистрация устройств.
//
// Транспорт и заголовки (§2 документа 12). Путь Connect: `/yofis.v1.<Service>/<Method>`.
// Уровни доступа методов:
//   public  — без заголовков;
//   session — `Authorization: Bearer <session_token>`;
//   signed  — session + подпись устройства (ADR-005):
//             `X-Yofis-Device: <device_id>`, `X-Yofis-Timestamp: <unix-секунды UTC, окно ±300 с>`,
//             `X-Yofis-Nonce: <16 случайных байт, base64url; уникален 5 мин>`,
//             `X-Yofis-Signature: base64url(Sign(device_private_key,
//                 <method_path> ‖ <timestamp> ‖ <nonce> ‖ <request_body_bytes>))`;
//   admin   — signed + роль ADMIN/OWNER узла.
// Всегда: `X-Yofis-Client: Yofis/<версия> (<платформа>; <ОС>)`, `Accept-Language`.
// Сессия скользящая (TTL продлевается активностью), абсолютный максимум — `NodeSettings.session_max_days`.

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=ts"
// @generated from file yofis/v1/auth.proto (package yofis.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { DeviceRegistration, User } from "./common_pb.ts";
import { file_yofis_v1_common } from "./common_pb.ts";
import type { NodeInfo } from "./node_pb.ts";
import { file_yofis_v1_node } from "./node_pb.ts";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yofis/v1/auth.proto.
 */
export const file_yofis_v1_auth: GenFile = /*@__PURE__*/
  fileDesc("ChN5b2Zpcy92MS9hdXRoLnByb3RvEgh5b2Zpcy52MSKhAQoHU2Vzc2lvbhIVCg1zZXNzaW9uX3Rva2VuGAEgASgJEhEKCWRldmljZV9pZBgCIAEoCRIaCgJtZRgDIAEoCzIOLnlvZmlzLnYxLlVzZXISLgoKZXhwaXJlc19hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASIAoEbm9kZRgFIAEoCzISLnlvZmlzLnYxLk5vZGVJbmZvImkKGExvZ2luV2l0aFBhc3N3b3JkUmVxdWVzdBINCgVsb2dpbhgBIAEoCRIQCghwYXNzd29yZBgCIAEoCRIsCgZkZXZpY2UYAyABKAsyHC55b2Zpcy52MS5EZXZpY2VSZWdpc3RyYXRpb24iPwoZTG9naW5XaXRoUGFzc3dvcmRSZXNwb25zZRIiCgdzZXNzaW9uGAEgASgLMhEueW9maXMudjEuU2Vzc2lvbiJCChVCZWdpbk9pZGNMb2dpblJlcXVlc3QSEwoLcHJvdmlkZXJfaWQYASABKAkSFAoMcmVkaXJlY3RfdXJpGAIgASgJIkIKFkJlZ2luT2lkY0xvZ2luUmVzcG9uc2USGQoRYXV0aG9yaXphdGlvbl91cmwYASABKAkSDQoFc3RhdGUYAiABKAkiZQoYQ29tcGxldGVPaWRjTG9naW5SZXF1ZXN0Eg0KBXN0YXRlGAEgASgJEgwKBGNvZGUYAiABKAkSLAoGZGV2aWNlGAMgASgLMhwueW9maXMudjEuRGV2aWNlUmVnaXN0cmF0aW9uIj8KGUNvbXBsZXRlT2lkY0xvZ2luUmVzcG9uc2USIgoHc2Vzc2lvbhgBIAEoCzIRLnlvZmlzLnYxLlNlc3Npb24ikgEKF1JlZ2lzdGVyQnlJbnZpdGVSZXF1ZXN0EhIKCmxpbmtfdG9rZW4YASABKAkSFAoMZGlzcGxheV9uYW1lGAIgASgJEhAKCHBhc3N3b3JkGAMgASgJEiwKBmRldmljZRgEIAEoCzIcLnlvZmlzLnYxLkRldmljZVJlZ2lzdHJhdGlvbhINCgVsb2dpbhgFIAEoCSI+ChhSZWdpc3RlckJ5SW52aXRlUmVzcG9uc2USIgoHc2Vzc2lvbhgBIAEoCzIRLnlvZmlzLnYxLlNlc3Npb24idgocQ29tcGxldGVQYXNzd29yZFJlc2V0UmVxdWVzdBISCgpsaW5rX3Rva2VuGAEgASgJEhQKDG5ld19wYXNzd29yZBgCIAEoCRIsCgZkZXZpY2UYAyABKAsyHC55b2Zpcy52MS5EZXZpY2VSZWdpc3RyYXRpb24iQwodQ29tcGxldGVQYXNzd29yZFJlc2V0UmVzcG9uc2USIgoHc2Vzc2lvbhgBIAEoCzIRLnlvZmlzLnYxLlNlc3Npb24iWAoUTG9naW5XaXRoTGlua1JlcXVlc3QSEgoKbGlua190b2tlbhgBIAEoCRIsCgZkZXZpY2UYAiABKAsyHC55b2Zpcy52MS5EZXZpY2VSZWdpc3RyYXRpb24iVQoVTG9naW5XaXRoTGlua1Jlc3BvbnNlEiIKB3Nlc3Npb24YASABKAsyES55b2Zpcy52MS5TZXNzaW9uEhgKEHBhc3N3b3JkX25vdF9zZXQYAiABKAgijgEKEkpvaW5Bc0d1ZXN0UmVxdWVzdBISCgpsaW5rX3Rva2VuGAEgASgJEhQKDGRpc3BsYXlfbmFtZRgCIAEoCRIsCgZkZXZpY2UYAyABKAsyHC55b2Zpcy52MS5EZXZpY2VSZWdpc3RyYXRpb24SIAoYcGhvbmVfdmVyaWZpY2F0aW9uX3Rva2VuGAQgASgJIjkKE0pvaW5Bc0d1ZXN0UmVzcG9uc2USIgoHc2Vzc2lvbhgBIAEoCzIRLnlvZmlzLnYxLlNlc3Npb24iVQoXUmVxdWVzdFBob25lQ29kZVJlcXVlc3QSDQoFcGhvbmUYASABKAkSKwoHcHVycG9zZRgCIAEoDjIaLnlvZmlzLnYxLlBob25lQ29kZVB1cnBvc2UiYAoYUmVxdWVzdFBob25lQ29kZVJlc3BvbnNlEhQKDGNoYWxsZW5nZV9pZBgBIAEoCRIuCgtyZXRyeV9hZnRlchgCIAEoCzIZLmdvb2dsZS5wcm90b2J1Zi5EdXJhdGlvbiI8ChZWZXJpZnlQaG9uZUNvZGVSZXF1ZXN0EhQKDGNoYWxsZW5nZV9pZBgBIAEoCRIMCgRjb2RlGAIgASgJIjsKF1ZlcmlmeVBob25lQ29kZVJlc3BvbnNlEiAKGHBob25lX3ZlcmlmaWNhdGlvbl90b2tlbhgBIAEoCSITChFHZXRTZXNzaW9uUmVxdWVzdCI4ChJHZXRTZXNzaW9uUmVzcG9uc2USIgoHc2Vzc2lvbhgBIAEoCzIRLnlvZmlzLnYxLlNlc3Npb24iDwoNTG9nb3V0UmVxdWVzdCIQCg5Mb2dvdXRSZXNwb25zZSIZChdMb2dvdXRBbGxEZXZpY2VzUmVxdWVzdCIaChhMb2dvdXRBbGxEZXZpY2VzUmVzcG9uc2UqgQEKEFBob25lQ29kZVB1cnBvc2USIgoeUEhPTkVfQ09ERV9QVVJQT1NFX1VOU1BFQ0lGSUVEEAASIwofUEhPTkVfQ09ERV9QVVJQT1NFX0dVRVNUX1ZFUklGWRABEiQKIFBIT05FX0NPREVfUFVSUE9TRV9TRUNPTkRfRkFDVE9SEAIylQgKC0F1dGhTZXJ2aWNlElwKEUxvZ2luV2l0aFBhc3N3b3JkEiIueW9maXMudjEuTG9naW5XaXRoUGFzc3dvcmRSZXF1ZXN0GiMueW9maXMudjEuTG9naW5XaXRoUGFzc3dvcmRSZXNwb25zZRJTCg5CZWdpbk9pZGNMb2dpbhIfLnlvZmlzLnYxLkJlZ2luT2lkY0xvZ2luUmVxdWVzdBogLnlvZmlzLnYxLkJlZ2luT2lkY0xvZ2luUmVzcG9uc2USXAoRQ29tcGxldGVPaWRjTG9naW4SIi55b2Zpcy52MS5Db21wbGV0ZU9pZGNMb2dpblJlcXVlc3QaIy55b2Zpcy52MS5Db21wbGV0ZU9pZGNMb2dpblJlc3BvbnNlElkKEFJlZ2lzdGVyQnlJbnZpdGUSIS55b2Zpcy52MS5SZWdpc3RlckJ5SW52aXRlUmVxdWVzdBoiLnlvZmlzLnYxLlJlZ2lzdGVyQnlJbnZpdGVSZXNwb25zZRJoChVDb21wbGV0ZVBhc3N3b3JkUmVzZXQSJi55b2Zpcy52MS5Db21wbGV0ZVBhc3N3b3JkUmVzZXRSZXF1ZXN0GicueW9maXMudjEuQ29tcGxldGVQYXNzd29yZFJlc2V0UmVzcG9uc2USSgoLSm9pbkFzR3Vlc3QSHC55b2Zpcy52MS5Kb2luQXNHdWVzdFJlcXVlc3QaHS55b2Zpcy52MS5Kb2luQXNHdWVzdFJlc3BvbnNlElAKDUxvZ2luV2l0aExpbmsSHi55b2Zpcy52MS5Mb2dpbldpdGhMaW5rUmVxdWVzdBofLnlvZmlzLnYxLkxvZ2luV2l0aExpbmtSZXNwb25zZRJZChBSZXF1ZXN0UGhvbmVDb2RlEiEueW9maXMudjEuUmVxdWVzdFBob25lQ29kZVJlcXVlc3QaIi55b2Zpcy52MS5SZXF1ZXN0UGhvbmVDb2RlUmVzcG9uc2USVgoPVmVyaWZ5UGhvbmVDb2RlEiAueW9maXMudjEuVmVyaWZ5UGhvbmVDb2RlUmVxdWVzdBohLnlvZmlzLnYxLlZlcmlmeVBob25lQ29kZVJlc3BvbnNlEkcKCkdldFNlc3Npb24SGy55b2Zpcy52MS5HZXRTZXNzaW9uUmVxdWVzdBocLnlvZmlzLnYxLkdldFNlc3Npb25SZXNwb25zZRI7CgZMb2dvdXQSFy55b2Zpcy52MS5Mb2dvdXRSZXF1ZXN0GhgueW9maXMudjEuTG9nb3V0UmVzcG9uc2USWQoQTG9nb3V0QWxsRGV2aWNlcxIhLnlvZmlzLnYxLkxvZ291dEFsbERldmljZXNSZXF1ZXN0GiIueW9maXMudjEuTG9nb3V0QWxsRGV2aWNlc1Jlc3BvbnNlQkUKEXJ1LnlvZmlzLnByb3RvLnYxUAFaJnlvZmlzLnJ1L3lvZmlzL2dlbi9nby95b2Zpcy92MTt5b2Zpc3YxugIFWW9maXNiBnByb3RvMw", [file_google_protobuf_duration, file_google_protobuf_timestamp, file_yofis_v1_common, file_yofis_v1_node]);

/**
 * Сессия устройства. Токен непрозрачный, привязан к устройству, отзываем.
 *
 * @generated from message yofis.v1.Session
 */
export type Session = Message<"yofis.v1.Session"> & {
  /**
   * Токен сессии для `Authorization: Bearer`.
   *
   * @generated from field: string session_token = 1;
   */
  sessionToken: string;

  /**
   * Идентификатор устройства для `X-Yofis-Device`.
   *
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * Текущий пользователь.
   *
   * @generated from field: yofis.v1.User me = 3;
   */
  me?: User | undefined;

  /**
   * Когда сессия истечёт без активности (скользящее окно).
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * Сведения об узле на момент входа (чтобы не ходить в `NodeService` отдельно).
   *
   * @generated from field: yofis.v1.NodeInfo node = 5;
   */
  node?: NodeInfo | undefined;
};

/**
 * Describes the message yofis.v1.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 0);

/**
 * Вход по паролю.
 *
 * @generated from message yofis.v1.LoginWithPasswordRequest
 */
export type LoginWithPasswordRequest = Message<"yofis.v1.LoginWithPasswordRequest"> & {
  /**
   * Адрес `localpart@domain`, localpart или e-mail.
   *
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * Пароль.
   *
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * Регистрируемое устройство.
   *
   * @generated from field: yofis.v1.DeviceRegistration device = 3;
   */
  device?: DeviceRegistration | undefined;
};

/**
 * Describes the message yofis.v1.LoginWithPasswordRequest.
 * Use `create(LoginWithPasswordRequestSchema)` to create a new message.
 */
export const LoginWithPasswordRequestSchema: GenMessage<LoginWithPasswordRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 1);

/**
 * Ответ на вход по паролю.
 *
 * @generated from message yofis.v1.LoginWithPasswordResponse
 */
export type LoginWithPasswordResponse = Message<"yofis.v1.LoginWithPasswordResponse"> & {
  /**
   * Сессия.
   *
   * @generated from field: yofis.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * Describes the message yofis.v1.LoginWithPasswordResponse.
 * Use `create(LoginWithPasswordResponseSchema)` to create a new message.
 */
export const LoginWithPasswordResponseSchema: GenMessage<LoginWithPasswordResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 2);

/**
 * Начало OIDC-входа.
 *
 * @generated from message yofis.v1.BeginOidcLoginRequest
 */
export type BeginOidcLoginRequest = Message<"yofis.v1.BeginOidcLoginRequest"> & {
  /**
   * Идентификатор провайдера из `NodeInfo.identity_providers`.
   *
   * @generated from field: string provider_id = 1;
   */
  providerId: string;

  /**
   * Куда провайдер вернёт пользователя (`yofis://…` или URL веб-клиента); должен быть разрешён на узле.
   *
   * @generated from field: string redirect_uri = 2;
   */
  redirectUri: string;
};

/**
 * Describes the message yofis.v1.BeginOidcLoginRequest.
 * Use `create(BeginOidcLoginRequestSchema)` to create a new message.
 */
export const BeginOidcLoginRequestSchema: GenMessage<BeginOidcLoginRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 3);

/**
 * Ответ на начало OIDC-входа.
 *
 * @generated from message yofis.v1.BeginOidcLoginResponse
 */
export type BeginOidcLoginResponse = Message<"yofis.v1.BeginOidcLoginResponse"> & {
  /**
   * URL авторизации у провайдера — клиент открывает его в системном браузере.
   *
   * @generated from field: string authorization_url = 1;
   */
  authorizationUrl: string;

  /**
   * `state` для `CompleteOidcLogin`; защита от CSRF.
   *
   * @generated from field: string state = 2;
   */
  state: string;
};

/**
 * Describes the message yofis.v1.BeginOidcLoginResponse.
 * Use `create(BeginOidcLoginResponseSchema)` to create a new message.
 */
export const BeginOidcLoginResponseSchema: GenMessage<BeginOidcLoginResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 4);

/**
 * Завершение OIDC-входа.
 *
 * @generated from message yofis.v1.CompleteOidcLoginRequest
 */
export type CompleteOidcLoginRequest = Message<"yofis.v1.CompleteOidcLoginRequest"> & {
  /**
   * `state` из `BeginOidcLoginResponse`.
   *
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * `code` из редиректа провайдера.
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * Регистрируемое устройство.
   *
   * @generated from field: yofis.v1.DeviceRegistration device = 3;
   */
  device?: DeviceRegistration | undefined;
};

/**
 * Describes the message yofis.v1.CompleteOidcLoginRequest.
 * Use `create(CompleteOidcLoginRequestSchema)` to create a new message.
 */
export const CompleteOidcLoginRequestSchema: GenMessage<CompleteOidcLoginRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 5);

/**
 * Ответ на завершение OIDC-входа.
 *
 * @generated from message yofis.v1.CompleteOidcLoginResponse
 */
export type CompleteOidcLoginResponse = Message<"yofis.v1.CompleteOidcLoginResponse"> & {
  /**
   * Сессия.
   *
   * @generated from field: yofis.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * Describes the message yofis.v1.CompleteOidcLoginResponse.
 * Use `create(CompleteOidcLoginResponseSchema)` to create a new message.
 */
export const CompleteOidcLoginResponseSchema: GenMessage<CompleteOidcLoginResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 6);

/**
 * Регистрация по инвайту администратора.
 *
 * @generated from message yofis.v1.RegisterByInviteRequest
 */
export type RegisterByInviteRequest = Message<"yofis.v1.RegisterByInviteRequest"> & {
  /**
   * Токен ссылки `USER_INVITE`.
   *
   * @generated from field: string link_token = 1;
   */
  linkToken: string;

  /**
   * Отображаемое имя.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * Пароль нового аккаунта; **необязателен** с 0.15 (ADR-036): пусто — учётная запись заводится
   * без пароля и сразу получает сессию, а пароль человек задаёт позже сам или не задаёт вовсе
   * (компании на OIDC он не нужен). Требовать секрет до того, как человек впервые увидел продукт, —
   * лишний барьер на самом первом шаге.
   *
   * @generated from field: string password = 3;
   */
  password: string;

  /**
   * Регистрируемое устройство.
   *
   * @generated from field: yofis.v1.DeviceRegistration device = 4;
   */
  device?: DeviceRegistration | undefined;

  /**
   * Желаемый localpart (0.5). Для **именного** инвайта (в нём задан login или email) игнорируется,
   * а при несовпадении — invalid_argument; для **общего** инвайта (`max_uses > 1`, без логина и почты) обязателен.
   * Формат: `[a-z0-9._-]{3,32}`, начинается с буквы, уникален на узле; `system` зарезервирован.
   *
   * @generated from field: string login = 5;
   */
  login: string;
};

/**
 * Describes the message yofis.v1.RegisterByInviteRequest.
 * Use `create(RegisterByInviteRequestSchema)` to create a new message.
 */
export const RegisterByInviteRequestSchema: GenMessage<RegisterByInviteRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 7);

/**
 * Ответ на регистрацию по инвайту.
 *
 * @generated from message yofis.v1.RegisterByInviteResponse
 */
export type RegisterByInviteResponse = Message<"yofis.v1.RegisterByInviteResponse"> & {
  /**
   * Сессия нового пользователя.
   *
   * @generated from field: yofis.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * Describes the message yofis.v1.RegisterByInviteResponse.
 * Use `create(RegisterByInviteResponseSchema)` to create a new message.
 */
export const RegisterByInviteResponseSchema: GenMessage<RegisterByInviteResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 8);

/**
 * Смена пароля по ссылке.
 *
 * @generated from message yofis.v1.CompletePasswordResetRequest
 */
export type CompletePasswordResetRequest = Message<"yofis.v1.CompletePasswordResetRequest"> & {
  /**
   * Токен ссылки `PASSWORD_RESET`.
   *
   * @generated from field: string link_token = 1;
   */
  linkToken: string;

  /**
   * Новый пароль.
   *
   * @generated from field: string new_password = 2;
   */
  newPassword: string;

  /**
   * Регистрируемое устройство.
   *
   * @generated from field: yofis.v1.DeviceRegistration device = 3;
   */
  device?: DeviceRegistration | undefined;
};

/**
 * Describes the message yofis.v1.CompletePasswordResetRequest.
 * Use `create(CompletePasswordResetRequestSchema)` to create a new message.
 */
export const CompletePasswordResetRequestSchema: GenMessage<CompletePasswordResetRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 9);

/**
 * Ответ на смену пароля.
 *
 * @generated from message yofis.v1.CompletePasswordResetResponse
 */
export type CompletePasswordResetResponse = Message<"yofis.v1.CompletePasswordResetResponse"> & {
  /**
   * Новая сессия; прежние сессии пользователя отозваны.
   *
   * @generated from field: yofis.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * Describes the message yofis.v1.CompletePasswordResetResponse.
 * Use `create(CompletePasswordResetResponseSchema)` to create a new message.
 */
export const CompletePasswordResetResponseSchema: GenMessage<CompletePasswordResetResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 10);

/**
 * Вход гостя по ссылке (v1.5).
 * Вход по ссылке (0.15).
 *
 * @generated from message yofis.v1.LoginWithLinkRequest
 */
export type LoginWithLinkRequest = Message<"yofis.v1.LoginWithLinkRequest"> & {
  /**
   * Токен ссылки `LINK_SCOPE_LOGIN` или `USER_INVITE`.
   *
   * @generated from field: string link_token = 1;
   */
  linkToken: string;

  /**
   * Регистрируемое устройство: к нему ссылка и привязывается, повторный обмен с другого устройства
   * не проходит даже внутри срока.
   *
   * @generated from field: yofis.v1.DeviceRegistration device = 2;
   */
  device?: DeviceRegistration | undefined;
};

/**
 * Describes the message yofis.v1.LoginWithLinkRequest.
 * Use `create(LoginWithLinkRequestSchema)` to create a new message.
 */
export const LoginWithLinkRequestSchema: GenMessage<LoginWithLinkRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 11);

/**
 * Ответ на вход по ссылке.
 *
 * @generated from message yofis.v1.LoginWithLinkResponse
 */
export type LoginWithLinkResponse = Message<"yofis.v1.LoginWithLinkResponse"> & {
  /**
   * Сессия — такая же, как у входа паролем.
   *
   * @generated from field: yofis.v1.Session session = 1;
   */
  session?: Session | undefined;

  /**
   * Пароль у учётной записи не задан: клиенту стоит предложить задать его, но не требовать.
   *
   * @generated from field: bool password_not_set = 2;
   */
  passwordNotSet: boolean;
};

/**
 * Describes the message yofis.v1.LoginWithLinkResponse.
 * Use `create(LoginWithLinkResponseSchema)` to create a new message.
 */
export const LoginWithLinkResponseSchema: GenMessage<LoginWithLinkResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 12);

/**
 * Вход внешнего участника встречи: учётной записи он не имеет и не заводит.
 *
 * @generated from message yofis.v1.JoinAsGuestRequest
 */
export type JoinAsGuestRequest = Message<"yofis.v1.JoinAsGuestRequest"> & {
  /**
   * Токен ссылки с `allows_guests == true`.
   *
   * @generated from field: string link_token = 1;
   */
  linkToken: string;

  /**
   * Отображаемое имя гостя — единственные его данные.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * Регистрируемое устройство.
   *
   * @generated from field: yofis.v1.DeviceRegistration device = 3;
   */
  device?: DeviceRegistration | undefined;

  /**
   * Токен подтверждения телефона из `VerifyPhoneCode`, если политика узла требует подтверждения для гостей.
   *
   * @generated from field: string phone_verification_token = 4;
   */
  phoneVerificationToken: string;
};

/**
 * Describes the message yofis.v1.JoinAsGuestRequest.
 * Use `create(JoinAsGuestRequestSchema)` to create a new message.
 */
export const JoinAsGuestRequestSchema: GenMessage<JoinAsGuestRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 13);

/**
 * Ответ на вход гостя.
 *
 * @generated from message yofis.v1.JoinAsGuestResponse
 */
export type JoinAsGuestResponse = Message<"yofis.v1.JoinAsGuestResponse"> & {
  /**
   * Сессия гостя; `me.kind == GUEST`. Чат/комната — через `LinkService.JoinByLink` с тем же токеном.
   *
   * @generated from field: yofis.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * Describes the message yofis.v1.JoinAsGuestResponse.
 * Use `create(JoinAsGuestResponseSchema)` to create a new message.
 */
export const JoinAsGuestResponseSchema: GenMessage<JoinAsGuestResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 14);

/**
 * Запрос кода на телефон (v1.5).
 *
 * @generated from message yofis.v1.RequestPhoneCodeRequest
 */
export type RequestPhoneCodeRequest = Message<"yofis.v1.RequestPhoneCodeRequest"> & {
  /**
   * Телефон в формате E.164 (`+79991234567`).
   *
   * @generated from field: string phone = 1;
   */
  phone: string;

  /**
   * Назначение кода.
   *
   * @generated from field: yofis.v1.PhoneCodePurpose purpose = 2;
   */
  purpose: PhoneCodePurpose;
};

/**
 * Describes the message yofis.v1.RequestPhoneCodeRequest.
 * Use `create(RequestPhoneCodeRequestSchema)` to create a new message.
 */
export const RequestPhoneCodeRequestSchema: GenMessage<RequestPhoneCodeRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 15);

/**
 * Ответ на запрос кода.
 *
 * @generated from message yofis.v1.RequestPhoneCodeResponse
 */
export type RequestPhoneCodeResponse = Message<"yofis.v1.RequestPhoneCodeResponse"> & {
  /**
   * Идентификатор проверки для `VerifyPhoneCode`.
   *
   * @generated from field: string challenge_id = 1;
   */
  challengeId: string;

  /**
   * Через сколько можно запросить код повторно.
   *
   * @generated from field: google.protobuf.Duration retry_after = 2;
   */
  retryAfter?: Duration | undefined;
};

/**
 * Describes the message yofis.v1.RequestPhoneCodeResponse.
 * Use `create(RequestPhoneCodeResponseSchema)` to create a new message.
 */
export const RequestPhoneCodeResponseSchema: GenMessage<RequestPhoneCodeResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 16);

/**
 * Проверка кода из SMS.
 *
 * @generated from message yofis.v1.VerifyPhoneCodeRequest
 */
export type VerifyPhoneCodeRequest = Message<"yofis.v1.VerifyPhoneCodeRequest"> & {
  /**
   * Идентификатор проверки.
   *
   * @generated from field: string challenge_id = 1;
   */
  challengeId: string;

  /**
   * Код из SMS.
   *
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message yofis.v1.VerifyPhoneCodeRequest.
 * Use `create(VerifyPhoneCodeRequestSchema)` to create a new message.
 */
export const VerifyPhoneCodeRequestSchema: GenMessage<VerifyPhoneCodeRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 17);

/**
 * Ответ на проверку кода.
 *
 * @generated from message yofis.v1.VerifyPhoneCodeResponse
 */
export type VerifyPhoneCodeResponse = Message<"yofis.v1.VerifyPhoneCodeResponse"> & {
  /**
   * Короткоживущий токен подтверждения телефона — для `JoinAsGuest` (или второго фактора).
   *
   * @generated from field: string phone_verification_token = 1;
   */
  phoneVerificationToken: string;
};

/**
 * Describes the message yofis.v1.VerifyPhoneCodeResponse.
 * Use `create(VerifyPhoneCodeResponseSchema)` to create a new message.
 */
export const VerifyPhoneCodeResponseSchema: GenMessage<VerifyPhoneCodeResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 18);

/**
 * Запрос текущей сессии; полей нет.
 *
 * @generated from message yofis.v1.GetSessionRequest
 */
export type GetSessionRequest = Message<"yofis.v1.GetSessionRequest"> & {
};

/**
 * Describes the message yofis.v1.GetSessionRequest.
 * Use `create(GetSessionRequestSchema)` to create a new message.
 */
export const GetSessionRequestSchema: GenMessage<GetSessionRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 19);

/**
 * Ответ с текущей сессией.
 *
 * @generated from message yofis.v1.GetSessionResponse
 */
export type GetSessionResponse = Message<"yofis.v1.GetSessionResponse"> & {
  /**
   * Сессия; `session_token` — тот же, что в запросе (ротация токена не делается).
   *
   * @generated from field: yofis.v1.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * Describes the message yofis.v1.GetSessionResponse.
 * Use `create(GetSessionResponseSchema)` to create a new message.
 */
export const GetSessionResponseSchema: GenMessage<GetSessionResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 20);

/**
 * Выход на текущем устройстве; полей нет.
 *
 * @generated from message yofis.v1.LogoutRequest
 */
export type LogoutRequest = Message<"yofis.v1.LogoutRequest"> & {
};

/**
 * Describes the message yofis.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 21);

/**
 * Ответ на выход; полей нет.
 *
 * @generated from message yofis.v1.LogoutResponse
 */
export type LogoutResponse = Message<"yofis.v1.LogoutResponse"> & {
};

/**
 * Describes the message yofis.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 22);

/**
 * Выход на всех устройствах; полей нет.
 *
 * @generated from message yofis.v1.LogoutAllDevicesRequest
 */
export type LogoutAllDevicesRequest = Message<"yofis.v1.LogoutAllDevicesRequest"> & {
};

/**
 * Describes the message yofis.v1.LogoutAllDevicesRequest.
 * Use `create(LogoutAllDevicesRequestSchema)` to create a new message.
 */
export const LogoutAllDevicesRequestSchema: GenMessage<LogoutAllDevicesRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 23);

/**
 * Ответ на выход везде; полей нет.
 *
 * @generated from message yofis.v1.LogoutAllDevicesResponse
 */
export type LogoutAllDevicesResponse = Message<"yofis.v1.LogoutAllDevicesResponse"> & {
};

/**
 * Describes the message yofis.v1.LogoutAllDevicesResponse.
 * Use `create(LogoutAllDevicesResponseSchema)` to create a new message.
 */
export const LogoutAllDevicesResponseSchema: GenMessage<LogoutAllDevicesResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_auth, 24);

/**
 * Назначение одноразового кода.
 *
 * @generated from enum yofis.v1.PhoneCodePurpose
 */
export enum PhoneCodePurpose {
  /**
   * Не задано.
   *
   * @generated from enum value: PHONE_CODE_PURPOSE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Подтверждение телефона гостя (политика узла).
   *
   * @generated from enum value: PHONE_CODE_PURPOSE_GUEST_VERIFY = 1;
   */
  GUEST_VERIFY = 1,

  /**
   * Второй фактор сотрудника (закладка).
   *
   * @generated from enum value: PHONE_CODE_PURPOSE_SECOND_FACTOR = 2;
   */
  SECOND_FACTOR = 2,
}

/**
 * Describes the enum yofis.v1.PhoneCodePurpose.
 */
export const PhoneCodePurposeSchema: GenEnum<PhoneCodePurpose> = /*@__PURE__*/
  enumDesc(file_yofis_v1_auth, 0);

/**
 * Вход и управление сессией текущего устройства.
 *
 * @generated from service yofis.v1.AuthService
 */
export const AuthService: GenService<{
  /**
   * Вход по логину и паролю; регистрирует устройство (публичный ключ) в том же вызове.
   * Уровень: public. Ошибки: INVALID_CREDENTIALS, USER_DEACTIVATED, MFA_REQUIRED (закладка).
   *
   * @generated from rpc yofis.v1.AuthService.LoginWithPassword
   */
  loginWithPassword: {
    methodKind: "unary";
    input: typeof LoginWithPasswordRequestSchema;
    output: typeof LoginWithPasswordResponseSchema;
  },
  /**
   * Начало входа через OIDC-провайдера: сервер отдаёт URL авторизации и `state`.
   * Уровень: public.
   *
   * @generated from rpc yofis.v1.AuthService.BeginOidcLogin
   */
  beginOidcLogin: {
    methodKind: "unary";
    input: typeof BeginOidcLoginRequestSchema;
    output: typeof BeginOidcLoginResponseSchema;
  },
  /**
   * Завершение входа через OIDC по `code` от провайдера; регистрирует устройство.
   * Уровень: public.
   *
   * @generated from rpc yofis.v1.AuthService.CompleteOidcLogin
   */
  completeOidcLogin: {
    methodKind: "unary";
    input: typeof CompleteOidcLoginRequestSchema;
    output: typeof CompleteOidcLoginResponseSchema;
  },
  /**
   * Регистрация сотрудника по ссылке `USER_INVITE`, выданной администратором.
   * Уровень: public. Ошибки: LINK_EXPIRED, LINK_REVOKED, LINK_EXHAUSTED, invalid_argument (логин).
   *
   * @generated from rpc yofis.v1.AuthService.RegisterByInvite
   */
  registerByInvite: {
    methodKind: "unary";
    input: typeof RegisterByInviteRequestSchema;
    output: typeof RegisterByInviteResponseSchema;
  },
  /**
   * Смена пароля по одноразовой ссылке `PASSWORD_RESET` из `AdminService.ResetPassword` (0.4); регистрирует устройство.
   * После успеха все прежние сессии пользователя отзываются.
   * Уровень: public. Ошибки: LINK_EXPIRED, LINK_REVOKED, LINK_EXHAUSTED, invalid_argument (слабый пароль).
   *
   * @generated from rpc yofis.v1.AuthService.CompletePasswordReset
   */
  completePasswordReset: {
    methodKind: "unary";
    input: typeof CompletePasswordResetRequestSchema;
    output: typeof CompletePasswordResetResponseSchema;
  },
  /**
   * Вход гостя по ссылке-праву без аккаунта (v1.5; `Capabilities.guests`).
   * Уровень: public. Ошибки: GUESTS_DISABLED, CAPABILITY_DISABLED, ошибки ссылок.
   *
   * @generated from rpc yofis.v1.AuthService.JoinAsGuest
   */
  joinAsGuest: {
    methodKind: "unary";
    input: typeof JoinAsGuestRequestSchema;
    output: typeof JoinAsGuestResponseSchema;
  },
  /**
   * Вход сотрудника по ссылке, без пароля (0.15, ADR-036): ссылка `LINK_SCOPE_LOGIN` или `USER_INVITE`
   * обменивается на обычную сессию. Ссылка предъявительская, поэтому она одноразовая, коротко живёт
   * и привязывается к первому устройству, которое её обменяло.
   * Уровень: public. Ошибки: LINK_EXPIRED, LINK_REVOKED, LINK_EXHAUSTED, RATE_LIMITED.
   *
   * @generated from rpc yofis.v1.AuthService.LoginWithLink
   */
  loginWithLink: {
    methodKind: "unary";
    input: typeof LoginWithLinkRequestSchema;
    output: typeof LoginWithLinkResponseSchema;
  },
  /**
   * Запрос одноразового кода на телефон (v1.5): подтверждение гостя или второй фактор.
   * Уровень: public. Ошибки: RATE_LIMITED, CAPABILITY_DISABLED.
   *
   * @generated from rpc yofis.v1.AuthService.RequestPhoneCode
   */
  requestPhoneCode: {
    methodKind: "unary";
    input: typeof RequestPhoneCodeRequestSchema;
    output: typeof RequestPhoneCodeResponseSchema;
  },
  /**
   * Проверка кода из SMS; возвращает токен подтверждения телефона (v1.5).
   * Уровень: public.
   *
   * @generated from rpc yofis.v1.AuthService.VerifyPhoneCode
   */
  verifyPhoneCode: {
    methodKind: "unary";
    input: typeof VerifyPhoneCodeRequestSchema;
    output: typeof VerifyPhoneCodeResponseSchema;
  },
  /**
   * Проверка живости сессии и обновление `me`.
   * Уровень: session. Ошибки: SESSION_EXPIRED, SESSION_REVOKED.
   *
   * @generated from rpc yofis.v1.AuthService.GetSession
   */
  getSession: {
    methodKind: "unary";
    input: typeof GetSessionRequestSchema;
    output: typeof GetSessionResponseSchema;
  },
  /**
   * Выход на текущем устройстве: сессия отзывается, устройство остаётся зарегистрированным.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.AuthService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * Выход на всех устройствах пользователя: все сессии отзываются, остальные клиенты получают `SessionRevoked`.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.AuthService.LogoutAllDevices
   */
  logoutAllDevices: {
    methodKind: "unary";
    input: typeof LogoutAllDevicesRequestSchema;
    output: typeof LogoutAllDevicesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yofis_v1_auth, 0);

